module.exports = __webpack_public_path__ + "assets/img/6.690a4455.jpg";